module.exports = __webpack_public_path__ + "img/Screen04.fb378970.svg";